import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IDeliveryTypePriceInfoDto, IFeeTaxesDto, ITipDto } from '../models';

@Injectable()
export class PaymentService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getDeliveryTypePriceInfo(
    id: number
  ): Observable<IDeliveryTypePriceInfoDto> {
    return this.get(`payment/deliveryTypePriceInfo/${id}`);
  }

  public getTip(id: number): Observable<ITipDto[]> {
    return this.get(`payment/tip/${id}`);
  }

  public getFeeTaxes(id: number): Observable<IFeeTaxesDto> {
    return this.get(`payment/feeTaxes/${id}`);
  }
}
